import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Proveedor } from "@/shared/types/proveedor";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteProveedor(id: string): Promise<Proveedor> {
    await sleep(1000);
    const response = await api.delete("proveedores/" + id);
    return response.data;
}

export function useDeleteProveedorMutation(id: string, mutationConfig: MutationConfig<Proveedor> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteProveedor(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["proveedores"] });
        },
    })
}

export interface DeleteProveedorMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Proveedor>,
    children?:(mutationResult:MutationResult<Proveedor>)=>ReactNode
}

export function DeleteProveedorMutation({
    id,
    children,
    mutationConfig
}:DeleteProveedorMutationProps){
    const mutationResult = useDeleteProveedorMutation(id, mutationConfig);
    return children&&children(mutationResult)
}